'use client'

import Image from 'next/image'
import type { JSX } from 'react'

import { cn } from '@src/utils/tailwind'

import caretIcon from '../_assets/caret.svg'

interface AccountSettingsItemProps {
  iconSrc: string
  iconAlt: string
  title: string
  description: string | JSX.Element
  ctaText?: string
  onClick?: () => void
  href?: string
  target?: string
  'data-testid'?: string
}

export function AccountSettingsItem({
  iconSrc,
  iconAlt,
  title,
  description,
  ctaText,
  onClick,
  href,
  target,
  'data-testid': dataTestId,
}: AccountSettingsItemProps) {
  const Container = href ? 'a' : 'div'
  return (
    <Container
      data-testid={dataTestId}
      className={cn(
        'flex w-full items-center gap-2 rounded-[14px] p-4 outline outline-1 outline-bodi-gray-butters lg:gap-6 lg:rounded-[30px] lg:p-8',
        'hover:outline-2 hover:outline-bodi-black-text focus:outline-2 focus:outline-bodi-black-text'
      )}
      role="button"
      tabIndex={0}
      onClick={onClick}
      href={href}
      target={target}
      onKeyDown={(e) => e.key === 'Enter' && onClick?.()}
    >
      <Image className="size-6 lg:size-8" src={iconSrc} alt={iconAlt} />
      <div className="flex flex-1 flex-col gap-0 pr-4 lg:gap-2">
        <h5 className="text-heading-5">{title}</h5>
        <div className="text-body-sm text-bodi-gray-medium">{description}</div>
      </div>
      <div className="text-body-lg font-medium text-bodi-green-deep-500 underline">
        {ctaText ?? <Image src={caretIcon} alt="cta icon" height={18} />}
      </div>
    </Container>
  )
}
